<template>
  <div v-if="currentStyle">
    <template v-for="input of inputs">
      <ruleGroupInput
        v-if="input.children && input.children.length > 0"
        :key="input.value"
        :field="input"
        v-model="currentStyle"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      />
      <rule-field-name
        v-else-if="input.type == 'field-label'"
        :label="input.label"
        :key="input.value + '-label'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-name>
      <rule-field-array
        v-else-if="input.type == 'field-array'"
        :label="input.label"
        :key="input.value + '-array'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-array>
      <ruleInput
        v-else
        :typeInput="input.type"
        :label="input.label"
        :key="input.value + '-else'"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></ruleInput>
    </template>

    <v-btn
      v-if="otherInput.length > 0"
      text
      @click="isAdvanced = !isAdvanced"
      :color="isAdvanced ? 'primary' : ''"
    >
      {{ $t('preview.actions.advanced') }}
    </v-btn>
    <template v-if="isAdvanced">
      <ruleInput
        :typeInput="input.type"
        v-for="input of otherInput"
        :key="input.value"
        :label="input.label"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.label"
      ></ruleInput>
    </template>
  </div>
</template>

<script>
import asyncComponent from '@/src/components/async'

import ruleGroupInput from '../input/edit-rule-group-input.vue'
import ruleInput from '../input/edit-rule-input.vue'

export default {
  components: {
    ruleInput,
    ruleGroupInput,
    RuleFieldName: () => asyncComponent(import('../input/rule-field-name.vue')),
    RuleFieldArray: () =>
      asyncComponent(import('../input/rule-field-array.vue')),
  },
  props: {
    value: {},
    typeLayer: String,
    fields: { type: Array },
  },
  data: () => ({
    isAdvanced: false,
    otherInput: [],
    inputs: [],
    currentStyle: {},
  }),
  watch: {
    value: {
      handler(value) {
        this.currentStyle = value || {}
      },
      immediate: true,
      deep: true,
    },
    typeLayer: {
      handler(value) {
        let input = defautInput[value] || Text
        this.inputs = input.default
        this.otherInput = input.other
        this.isAdvanced = false
      },
      immediate: true,
    },
  },
  methods: {
    changeStyle() {
      this.$emit('input', this.currentStyle)
    },
  },
}

let Point = {
  default: [
    {
      label: 'Biểu tượng',
      value: 'icon',
      type: 'icon',
    },
    {
      label: 'Độ trong suốt',
      value: 'opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Kích cỡ',
      value: 'size',
      acceptsExpression: true,
      defaultValue: 1,
      type: 'integer',
      option: {
        min: 0,
      },
    },
  ],
  other: [],
}
let Polygon = {
  default: [
    {
      label: 'Màu',
      value: 'fill',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ trong suốt',
      value: 'fill-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    // {
    //   label: 'Sử dụng viển?',
    //   value: 'use_stroke',
    //   children: [
    //     {
    //       label: 'Màu viền',
    //       value: 'stroke',
    //       type: 'color',
    //       acceptsExpression: true,
    //       defaultValue: '#000000',
    //     },
    //     {
    //       label: 'Độ dày',
    //       value: 'stroke-width',
    //       type: 'length',
    //       acceptsExpression: true,
    //       defaultValue: 1,
    //     },
    //     {
    //       label: 'Độ trong suốt viền',
    //       value: 'stroke-opacity',
    //       type: 'percentage',
    //       defaultValue: 1,
    //     },
    //   ],
    // },
  ],
  other: [],
}
let Line = {
  default: [
    {
      label: 'Màu viền',
      value: 'stroke',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ dày',
      value: 'stroke-width',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Độ trong suốt viền',
      value: 'stroke-opacity',
      type: 'percentage',
      defaultValue: 1,
    },
    {
      label: 'Dasharray',
      value: 'stroke-dasharray',
      type: 'field-array',
      defaultValue: [],
    },
    {
      label: 'Chóp',
      value: 'line-cap',
      type: 'v-select',
      defaultValue: 'butt',
      option: {
        items: [
          { text: 'butt', value: 'butt' },
          { text: 'round', value: 'round' },
          { text: 'square', value: 'square' },
        ],
      },
    },
    {
      label: 'Khớp nối',
      value: 'line-join',
      type: 'v-select',
      defaultValue: 'miter',
      option: {
        items: [
          { text: 'miter', value: 'miter' },
          { text: 'round', value: 'round' },
          { text: 'bevel', value: 'bevel' },
          { text: 'none', value: 'none' },
        ],
      },
    },
  ],
  other: [],
}
let Text = {
  default: [
    {
      label: 'Trường hiển thị',
      value: 'label',
      type: 'field-label',
      defaultValue: 'name',
    },
    {
      label: 'Phông chữ',
      value: 'font-family',
      type: 'font',
    },
    {
      label: 'Kiểu',
      value: 'font-style',
      type: 'v-select',
      option: {
        items: [
          { text: 'Bình thường', value: 'normal' },
          { text: 'In đậm', value: 'bold' },
          { text: 'In nghiêng', value: 'italic' },
          { text: 'Gạch chân', value: 'oblique' },
        ],
      },
    },
    {
      label: 'Kích cỡ',
      value: 'font-size',
      defaultValue: 10,
      type: 'integer',
      option: {
        min: 0,
      },
    },
    {
      label: 'Màu',
      value: 'fill',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ trong suốt',
      value: 'fill-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
  ],
  other: [],
}

let defautInput = { Point, Polygon, Line, Text }
</script>

<style></style>
